import styled from 'styled-components';

const Input = styled.input.attrs({
  autoComplete: 'off'
})`
  display: block;
  width: 100%;
  height: 40px;
  padding: 2px 2px 1px 15px;
  font-size: 15px;
  border: 1px solid #d1d1d1;
  outline: none;
  box-sizing: border-box;

  &:disabled,
  &:read-only {
    color: #585858;
    background-color: #f1f1f1;
  }

  &[type="number"]::-webkit-outer-spin-button,
  &[type="number"]::-webkit-inner-spin-button {
    /* display: none; <- Crashes Chrome on hover */
    appearance: none;
    margin: 0; /* <-- Apparently some margin are still there even though it's hidden */
  }
`

export default Input;


// WEBPACK FOOTER //
// ./client/components/Styled/Input/index.js